<template>
    <div class="add-package" style="max-height: 600px; overflow: auto">
        <div class="group">
            <h1>叠加包</h1>
            <div>
                <div v-for="(item, index) in packageOne" :key="index">
                    <input
                        type="radio"
                        name="packageIds"
                        :value="item.id"
                        v-model="packageIds"
                    />
                    <span> <strong>套餐名称：</strong>{{ item.name }}</span>
                    <span>
                        <strong>&nbsp;&nbsp;&nbsp; 所属运营商： </strong
                        >{{ item.accountName }}</span
                    >
                    <span>
                        <strong>&nbsp;&nbsp; 套餐数量： </strong>
                        {{ item.cardCount }}</span
                    >
                    <span
                        ><strong>&nbsp;&nbsp; 充值价格： </strong
                        >{{ item.money }} 元</span
                    >
                </div>
            </div>
        </div>
        <div class="group">
            <h1>叠加包(语音)</h1>
            <div>
                <div v-for="(item, index) in packageVoice" :key="index">
                    <input
                        type="radio"
                        name="packageIds"
                        :value="item.id"
                        v-model="packageIds"
                    />
                    <!-- <span>{{item.name}}({{item.accountName}})</span> -->
                    <span> <strong>套餐名称：</strong>{{ item.name }}</span>
                    <span>
                        <strong>&nbsp;&nbsp;&nbsp; 所属运营商： </strong
                        >{{ item.accountName }}</span
                    >
                    <span>
                        <strong>&nbsp;&nbsp; 套餐数量： </strong>
                        {{ item.cardCount }}</span
                    >
                    <span
                        ><strong>&nbsp;&nbsp; 充值价格： </strong
                        >{{ item.money }} 元</span
                    >
                </div>
            </div>
        </div>
        <div class="group">
            <h1>基础套餐</h1>
            <div v-show="showBasic">
                <div class="search-area">
                    <el-form :inline="true" class="search-form">
                        <el-form-item label="套餐名称:">
                            <el-input
                                v-model="searchForm.mealName"
                                placeholder="请输入套餐名称"
                                clearable
                            >
                            </el-input>
                        </el-form-item>

                        <el-form-item label="运营商:">
                            <el-select
                                v-model="searchForm.accountId"
                                filterable
                            >
                                <el-option
                                    v-for="item in accountLists"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.label"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="卡组合类型:">
                            <el-select
                                v-model="searchForm.cardType"
                                placeholder="请选择卡组合类型"
                                clearable
                            >
                                <el-option label="请选择" value="0"></el-option>
                                <el-option
                                    label="单网套餐(电信)"
                                    value="1"
                                ></el-option>
                                <el-option
                                    label="单网套餐(联通)"
                                    value="2"
                                ></el-option>
                                <el-option
                                    label="单网套餐(移动)"
                                    value="3"
                                ></el-option>
                                <el-option
                                    label="双网套餐(电信+联通)"
                                    value="4"
                                ></el-option>
                                <el-option
                                    label="双网套餐(电信+移动)"
                                    value="5"
                                ></el-option>
                                <el-option
                                    label="双网套餐(移动+联通)"
                                    value="6"
                                ></el-option>
                                <el-option
                                    label="三网套餐(三网通)"
                                    value="7"
                                ></el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item>
                            <el-button type="primary" @click="handleSearch"
                                >搜索</el-button
                            >
                            <el-button @click="resetSearch">重置</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div v-for="(item, index) in packageBasic" :key="index">
                    <input
                        type="radio"
                        name="packageIds"
                        :value="item.id"
                        v-model="packageIds"
                    />
                    <!-- <span>{{item.name}}({{item.accountName}})</span>
                 <span v-show="item.cardCount">({{item.cardCount}})</span> -->
                    <span> <strong>套餐名称：</strong>{{ item.name }}</span>
                    <span>
                        <strong>&nbsp;&nbsp;&nbsp; 所属运营商： </strong
                        >{{ item.accountName }}</span
                    >
                    <span>
                        <strong>&nbsp;&nbsp; 套餐数量： </strong>
                        {{ item.cardCount }}</span
                    >
                    <span
                        ><strong>&nbsp;&nbsp; 充值价格： </strong
                        >{{ item.money }} 元</span
                    >
                    <span v-if="item && item.viewClassifyType"
                        ><strong>&nbsp;&nbsp; 卡组合类型： </strong
                        >{{ showType(item.viewClassifyType) }}
                    </span>
                </div>
            </div>
        </div>
        <div class="foot">
            <el-button
                type="primary"
                class="themed-button"
                @click="sure"
                v-preventReClick="2000"
                :disabled="isDisable"
                >确定</el-button
            >
            <el-button type="primary" class="themed-button" @click="reset"
                >重置</el-button
            >
            <el-button type="primary" class="themed-button" @click="close"
                >取 消</el-button
            >
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
import { getAccountList } from "@/api/cardManagement/cardBill.js";
import { mealRecharge } from "@/api/cardManagement/cardBillDetail.js";
import dictGroup from "@/mixins/dictGroup.js";

export default {
    props: ["addPackageData", "curInfor"],
    mixins: [dictGroup],
    data() {
        return {
            showBasic: true,
            packageIds: "",
            packageOne: [],
            packageVoice: [],
            packageBasic: [],
            isDisable: false,
            searchForm: {
                mealName: "",
                accountId: "",
                cardType: "",
            },
            accountLists: [{ label: "请选择", value: "" }],
        };
    },
    mounted() {
        this._getAccountList();
        this.dateShow(true);
    },
    methods: {
        showType(type) {
            // 0、默认，1、单网套餐（电信），2、单网套餐（联通），3、单网套餐（移动），4、双网套餐（电信+联通），5、双网套餐（电信+移动），6,、双网套餐（移动+联通），7、三网套餐（三网通）
            if (type == 1) {
                return "单网套餐(电信)";
            } else if (type == 2) {
                return "单网套餐(联通)";
            } else if (type == 3) {
                return "单网套餐(移动)";
            } else if (type == 4) {
                return "双网套餐(电信+联通)";
            } else if (type == 5) {
                return "双网套餐(电信+移动)";
            } else if (type == 6) {
                return "双网套餐(移动+联通)";
            } else if (type == 7) {
                return "三网套餐(三网通)";
            } else if (
                type == 0 ||
                type == null ||
                type == undefined ||
                type == ""
            ) {
                return "默认";
            }
        },
        _getAccountList() {
            getAccountList().then((res) => {
                this.accountLists = [{ label: "请选择", value: "" }];
                if (res.length > 0) {
                    res.forEach((item) => {
                        this.accountLists.push({
                            label: item.accountName,
                            value: item.id,
                        });
                    });
                }
            });
        },
        handleSearch() {
            this.dateShow(false);
        },
        resetSearch() {
            this.searchForm = {
                mealName: "",
                accountId: "",
                cardType: "",
            };
            this.dateShow(false);
        },
        sure() {
            if (!this.packageIds) {
                return;
            }
            this.isDisable = true;
            let params = {};
            params.iccidOrPhone = this.curInfor.iccidMark;
            params.setMealId = this.curInfor.setMealId;
            params.isChild = this.curInfor.isChild;
            params.codeChild = this.curInfor.codeChild;
            params.packageIds = this.packageIds;
            params.countNum = 1;
            params.effectType = 1;
            mealRecharge(params)
                .then((res) => {
                    this.isDisable = false;
                    this.$alert("充值成功", "提示", {
                        confirmButtonText: "确定",
                        callback: (action) => {
                            this.close();
                        },
                    });
                    return;
                })
                .catch(() => {
                    this.isDisable = false;
                });
        },
        reset() {
            this.packageIds = "";
        },
        close() {
            this.$emit("close");
        },
        dateShow(type) {
            this.packageOne = [];
            this.packageVoice = [];
            this.packageBasic = [];
            let list = this.addPackageData;
            if (list && typeof list !== "undefined" && list.length > 0) {
                var cardSecondCode = "";
                if (type) {
                    list.forEach((item) => {
                        if (1 == item.type) return;
                        if (101 == item.type) return;
                        if (2 == item.type)
                            return (item.cardCount = item.cardCount + "月");
                        if (3 == item.type)
                            return (item.cardCount = item.cardCount + "月");
                        if (4 == item.type)
                            return (item.cardCount = item.cardCount + "月");
                        if (5 == item.type)
                            return (item.cardCount = item.cardCount + "月");
                        if (6 == item.type) return;
                        if (7 == item.type)
                            return (item.cardCount = item.cardCount + "天");
                        if (8 == item.type) return;
                        if (9 == item.type)
                            return (item.cardCount = item.cardCount + "月");
                        if (11 == item.type)
                            if (item.termType == 1) {
                                return (item.cardCount = item.cardCount + "月");
                            } else if (item.termType == 2) {
                                return (item.cardCount = item.cardCount + "天");
                            }
                        if (13 == item.type) return;
                        if (99 == item.type) return;
                        if (14 == item.type)
                            return (item.cardCount = item.cardCount + "月");
                        if (15 == item.type)
                            return (item.cardCount = item.cardCount + "月");
                        if (20 == item.type)
                            return (item.cardCount = item.cardCount + "月");
                        if (21 == item.type)
                            return (item.cardCount = item.cardCount + "月");
                        if (23 == item.type) {
                            return (item.cardCount = item.cardCount + "月");
                        }
                        if (33 == item.type) {
                            return;
                        }
                        if (40 == item.type) {
                            return;
                        }
                    });
                }

                list.forEach((item) => {
                    if (
                        item.id === this.curInfor.setMealId &&
                        item.secondIsChild === "2"
                    ) {
                        cardSecondCode = item.secondCodeChild;
                        return;
                    }
                });
                list.forEach((item) => {
                    if (
                        item.type ==
                        this._getDictValue("DJB_", this.w_packageType)
                    ) {
                        this.packageOne.push({
                            id: item.id,
                            name: item.name,
                            accountName: item.accountName,
                            cardCount: item.cardCount,
                            money: item.money,
                        });
                    } else if (
                        item.type ==
                        this._getDictValue("YYDJB_", this.w_packageType)
                    ) {
                        console.log(item.id);
                        this.packageVoice.push({
                            id: item.id,
                            name: item.name,
                            accountName: item.accountName,
                            cardCount: item.cardCount,
                            money: item.money,
                        });
                    } else {
                        let setMealId = this.curInfor.setMealId;
                        let isChild = this.curInfor.isChild;
                        let codeChild = this.curInfor.codeChild;

                        if (cardSecondCode && cardSecondCode !== "") {
                            if (item.secondCodeChild === cardSecondCode) {
                                console.log(item.id);
                                this.packageBasic.push({
                                    id: item.id,
                                    name: item.name,
                                    cardCount: item.cardCount,
                                    accountName: item.accountName,
                                    money: item.money,
                                    viewClassifyType: item.viewClassifyType,
                                });
                                // 添加搜索过滤
                                this.packageBasic = this.packageBasic.filter(
                                    (item) => {
                                        let nameMatch = true;
                                        let accountMatch = true;
                                        let typeMatch = true;

                                        if (this.searchForm.mealName) {
                                            nameMatch =
                                                item.name &&
                                                item.name
                                                    .toLowerCase()
                                                    .includes(
                                                        this.searchForm.mealName
                                                            .trim()
                                                            .toLowerCase()
                                                    );
                                        }

                                        if (
                                            this.searchForm.accountId &&
                                            this.searchForm.accountId !=
                                                "请选择"
                                        ) {
                                            accountMatch =
                                                item.accountName ==
                                                this.searchForm.accountId;
                                        }

                                        if (
                                            this.searchForm.cardType &&
                                            this.searchForm.cardType != "0"
                                        ) {
                                            typeMatch =
                                                item.viewClassifyType ==
                                                this.searchForm.cardType;
                                        }

                                        return (
                                            nameMatch &&
                                            accountMatch &&
                                            typeMatch
                                        );
                                    }
                                );
                            }
                        } else {
                            if (isChild == "1") {
                                if (item.id == setMealId) {
                                    console.log(item.id);
                                    this.packageBasic.push({
                                        id: item.id,
                                        name: item.name,
                                        cardCount: "",
                                        accountName: item.accountName,
                                        money: item.money,
                                        viewClassifyType: item.viewClassifyType,
                                    });
                                    // 添加搜索过滤
                                    this.packageBasic =
                                        this.packageBasic.filter((item) => {
                                            let nameMatch = true;
                                            let accountMatch = true;
                                            let typeMatch = true;

                                            if (this.searchForm.mealName) {
                                                nameMatch =
                                                    item.name &&
                                                    item.name
                                                        .toLowerCase()
                                                        .includes(
                                                            this.searchForm.mealName
                                                                .trim()
                                                                .toLowerCase()
                                                        );
                                            }

                                            if (
                                                this.searchForm.accountId &&
                                                this.searchForm.accountId !=
                                                    "请选择"
                                            ) {
                                                accountMatch =
                                                    item.accountName ==
                                                    this.searchForm.accountId;
                                            }

                                            if (
                                                this.searchForm.cardType &&
                                                this.searchForm.cardType != "0"
                                            ) {
                                                typeMatch =
                                                    item.viewClassifyType ==
                                                    this.searchForm.cardType;
                                            }

                                            return (
                                                nameMatch &&
                                                accountMatch &&
                                                typeMatch
                                            );
                                        });
                                }
                            } else {
                                this.showBasic = false;
                                console.log(item.id);
                                if (item.codeChild == codeChild) {
                                    this.packageBasic.push({
                                        id: item.id,
                                        name: item.name,
                                        cardCount: item.cardCount,
                                        accountName: item.accountName,
                                        money: item.money,
                                        viewClassifyType: item.viewClassifyType,
                                    });
                                }
                                // 添加搜索过滤
                                this.packageBasic = this.packageBasic.filter(
                                    (item) => {
                                        let nameMatch = true;
                                        let accountMatch = true;
                                        let typeMatch = true;

                                        if (this.searchForm.mealName) {
                                            nameMatch =
                                                item.name &&
                                                item.name
                                                    .toLowerCase()
                                                    .includes(
                                                        this.searchForm.mealName
                                                            .trim()
                                                            .toLowerCase()
                                                    );
                                        }

                                        if (
                                            this.searchForm.accountId &&
                                            this.searchForm.accountId !=
                                                "请选择"
                                        ) {
                                            accountMatch =
                                                item.accountName ==
                                                this.searchForm.accountId;
                                        }

                                        if (
                                            this.searchForm.cardType &&
                                            this.searchForm.cardType != "0"
                                        ) {
                                            typeMatch =
                                                item.viewClassifyType ==
                                                this.searchForm.cardType;
                                        }

                                        return (
                                            nameMatch &&
                                            accountMatch &&
                                            typeMatch
                                        );
                                    }
                                );
                            }
                        }
                    }
                });
            }
        },
    },
};
</script>

<style>
.add-package .foot {
    text-align: right;
}
</style>
